function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx } from "react/jsx-runtime";
import { ICON_PROMO } from "@config/constants";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { openPromotions } from "@common/actions";
import { castArray, isEmpty } from "lodash";
var PromoIcon = function(param) {
    var _$openPromotions = param.openPromotions, userDetails = param.userDetails, prismic = param.prismic;
    var _prismic_subscriptions;
    var plans_items = castArray((prismic === null || prismic === void 0 ? void 0 : (_prismic_subscriptions = prismic.subscriptions) === null || _prismic_subscriptions === void 0 ? void 0 : _prismic_subscriptions.plans_items) || []);
    var currentPlan = useMemo(function() {
        if (!isEmpty(plans_items) && !isEmpty(userDetails === null || userDetails === void 0 ? void 0 : userDetails.subscription)) {
            return plans_items.find(function(plan) {
                return plan.id === userDetails.subscription[0].planId;
            });
        }
        return null;
    }, [
        plans_items,
        userDetails
    ]);
    var _openPromotions = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (!isEmpty(currentPlan)) {
                    _$openPromotions(currentPlan);
                }
                return [
                    2
                ];
            });
        });
        return function _openPromotions() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isEmpty(currentPlan)) return null;
    return /*#__PURE__*/ _jsx("span", {
        className: "promo-icon",
        onClick: _openPromotions,
        children: /*#__PURE__*/ _jsx("img", {
            src: ICON_PROMO,
            alt: "promo-icon"
        })
    });
};
var mapStateToProps = function(param) {
    var userDetails = param.userDetails, prismic = param.prismic;
    return {
        userDetails: userDetails,
        prismic: prismic
    };
};
export default withRouter(connect(mapStateToProps, {
    openPromotions: openPromotions
})(PromoIcon));
